import React, { FC, ReactNode, useState } from 'react';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { BREAKPOINTS, useIsMobile } from '@buyside/util/hooks/useIsMobile';

import styles from './navigationUserInfoStyles.scss';

const NavigationUserInfoSection: FC<{
  title: string;
  children: ReactNode;
}> = ({ title, children }) => {
  const isMobile = useIsMobile(BREAKPOINTS.SMALL);

  const [isVisible, setIsVisible] = useState(!isMobile);

  return (
    <div className={styles.navigationUserInfoSection}>
      <div className={styles.navigationUserInfoSectionHeader}>
        <label>{title}</label>
        {isMobile ? (
          <button
            className={classNames(styles.navigationUserInfoSectionHeaderButton)}
            onClick={() => setIsVisible(!isVisible)}
          >
            <FontAwesomeIcon icon={isVisible ? faCaretUp : faCaretDown} />
          </button>
        ) : null}
      </div>
      <div
        className={classNames(styles.navigationUserInfoSectionContent, {
          [styles.visible]: isVisible || !isMobile
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default NavigationUserInfoSection;
